<fieldset>
  <legend class="h1">Berth</legend>

  @if (isIncomingTrip()) {
    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ETA pilot boarding place">
          <app-date-field
            class="mb-3"
            [formControl]="$any(form.control.get('portVisit').get('etaPbp'))"
            [required]="true">
          </app-date-field>
      </app-form-field>
    </fieldset>
    @if (!isPilotOnly()) {
    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="Pilot Boarding Place">
        <app-search
          class="mb-3"
          [formControl]="$any(form.control.get('portVisit').get('pbp'))"
          [options]="['LNG']"
          [required]="true"
          [placeholder]="'Type to search'">
        </app-search>
      </app-form-field>
    </fieldset>
    }
  }

  @if (isOutgoingTrip()) {
    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ATD port">
        <app-date-field
          class="mb-3"
          [formControl]="$any(form.control.get('portVisit').get('atdPort'))"
          [required]="true">
        </app-date-field>
      </app-form-field>
    </fieldset>
  } @else {
    @if (!isPilotOnly()) {
    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="Berth">
        <app-search
          class="mb-3"
          [ngModel]="selectedBerth()"
          (ngModelChange)="onBerthSelected($event)"
          [searchFunction]="searchBerth"
          [inputFormatter]="berthInputFormatter"
          [required]="true"
          placeholder="Find berth or buoy">
        </app-search>
      </app-form-field>
    </fieldset>
    }

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ETA">
        <app-date-field
          class="mb-3"
          [formControl]="$any(form.control.get('berth').get('eta'))"
          [required]="true">
        </app-date-field>
      </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ATA">
        <app-date-field
          class="mb-3"
          [formControl]="$any(form.control.get('berth').get('ata'))"
          [required]="true">
        </app-date-field>
      </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ETD">
        <app-date-field
          class="mb-3"
          [formControl]="$any(form.control.get('berth').get('etd'))"
          [required]="true">
        </app-date-field>
      </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="ATD">
        <app-date-field
          class="mb-3"
          [formControl]="$any(form.control.get('berth').get('atd'))"
          [required]="true">
        </app-date-field>
      </app-form-field>
    </fieldset>

    @if (!isPilotOnly()) {
    <fieldset class="d-flex gap-3 field-width">
      <app-form-field class="flex-fill" label="Bollards from">
        <input
          class="form-control"
          [formControl]="$any(form.control.get('berth').get('bollardFrom'))"
          [required]="true">
      </app-form-field>
      <app-form-field class="flex-fill" label="Bollards to">
        <input
          class="form-control"
          [formControl]="$any(form.control.get('berth').get('bollardTo'))"
          [required]="true">
      </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="Mooring position">
        <app-select
          class="mb-3"
          [formControl]="$any(form.control.get('berth').get('mooringPosition'))"
          [options]="moorings"
          [required]="true"
          [formatter]="mooringFormatter">
        </app-select>
      </app-form-field>
    </fieldset>
    }
  }
</fieldset>
